<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="options"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>

<script>
    /**
     * Allows the setting of payment orchestration step's action type
     */
    export default {
        name: 'ies-paymentAction',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                options: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.setOptions();
            if (!this.field.value){
                this.viewValue = 45;
            }
        },
        methods: {
            setOptions:function(){
                var options = [];
                options.push({ text: 'Charge Tokenised Card', value: 1 });
                options.push({ text: 'Delete 3DS Authentication Data', value: 2 });
                options.push({ text: 'Charge Card', value: 3 });
                this.options = options;
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
